// Shown for the owner in place of the role Identity gives them.
export const OWNER_ROLE_LABEL = 'Owner';
